import {AbstractControl, AsyncValidatorFn} from "@angular/forms";
import {Observable} from "rxjs/Observable";
import {BarcodeService} from "../../../../../identity/services/barcode.service";
import {appInjector} from "../../../../../index";
import {ERRCODE_BARCODE_IN_USE, ERRCODE_MISC} from "./validator-error-codes";
import {distinctUntilChanged} from "rxjs/operators";

/**
 * Created by afuhr on 04.01.2017.
 */

interface IAsynchronousBarcodeValidator {

}

function validateBarcode(cuid?: string | Observable<string>) {
  return (control: AbstractControl): Observable<IAsynchronousBarcodeValidator> => {
    // Get application injector and dirty-inject the barcode service
    let injector = appInjector();
    let bcService = injector.get(BarcodeService);

    // If no value is given, return valid
    if (!control.value) {
      return new Observable((obs: any) => {
        obs.next(null);
        obs.complete();
      });
    }

    return new Observable((obs: any) => {
      bcService.checkBarcode(control.value, cuid).pipe(
        distinctUntilChanged()
      ).subscribe(
        res => {
          obs.next(null);
          obs.complete();
        },
        error => {
          console.warn("Barcode already in use!", [cuid, control.value, error]);
          let errorCode = ERRCODE_MISC;

          if (error.graphQLErrors && error.graphQLErrors.find(e => e.message == "EAN already in use!")) {
            errorCode = ERRCODE_BARCODE_IN_USE;
          }
          obs.next({[errorCode]: true});
          obs.complete();
        }
      );
    });
  }
}

export class AsynchronousBarcodeValidator {

  static checkBarcode(stockCuid?: string | Observable<string>): AsyncValidatorFn {
    return <any> validateBarcode(stockCuid);
  }


}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/ui/forms/validators/barcode.async.validator.ts